import { MotifIcon } from "@ey-xd/motif-react";
import { mailToIcon } from '../../common/MotifIcons';
import { MSAL_CONFIG } from "../../common/security/authConfig";
import "../../components/error/error.scss"

const ErrorPage = () => {
    const handleLogout = () => {
        try {
            sessionStorage.clear();
            localStorage.clear();
        } catch (error) {
            // Handle case where sessionStorage & localStorage is not available
        }
        window.location.href = MSAL_CONFIG.auth.redirectUri;
    };

    return (
        <div className="error-page">
            <img src="Illustrations.png" alt="Error" className="error-page__image" />
            <h2 className="error-page__title">
                An Error Occurred
            </h2>
            <div className="error-page__message">
                <p>Oops! Something went wrong. An unknown error occurred.<br />Please try again after a while.</p>
                <p>If the problem persists, please contact technical support at<br />
                    <a
                        href="mailto:DBS@parthenon.ey.com"
                        className="error-page__support-link"
                        variant="text-alt"
                        size="medium"
                        state="default"
                        disabled={false}
                        type="button"
                        icon="default"
                        warn={false}
                    >
                        <MotifIcon src={mailToIcon} />
                        DBS@parthenon.ey.com
                    </a>
                </p>
            </div>
            <button
                className="error-page__button"
                variant="primary"
                size="medium"
                state="default"
                disabled={false}
                type="button"
                icon="default"
                warn={false}
                onClick={handleLogout}
            >
                Go back to Login
            </button>
        </div>
    );
};
export default ErrorPage;